import { GameRequest } from '@api/selfServe';
import { DataAccessProvider, SelfServeDataAccessStatus } from '@constants/constants';

export const accessGrantedResponse = (
  gameRequest: GameRequest,
  payload: {
    mmp: DataAccessProvider;
    accountName?: string;
    iapMargin?: string;
    iaaIdList?: string[];
    connectionDetails?: string;
  },
): GameRequest[] => {
  return [
    {
      ...gameRequest,
      requestStatus: SelfServeDataAccessStatus.ACCESS_GRANTED,
      ...payload,
      dataSourceMetadata: payload?.iaaIdList?.length
        ? JSON.stringify({
            iaaIdList: payload.iaaIdList,
          })
        : '',
    },
  ];
};
